var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tags)?_c('div',{staticClass:"c-item-tags"},_vm._l((_vm.tags),function(tag,i){return _c('span',{key:i},[_vm._v(" "+_vm._s(tag)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }